import trackWishlistActions from './trackWishlistActions';

function trackInlineRenameValidation (el) {

	if (el) {

		const inlineRenameErrorObserver = new MutationObserver((mutations) => {

			const { target } = mutations[0];
			const errorMessage = target.textContent;

			if (errorMessage) {

				trackWishlistActions({
					eventAction: 'Validate-List-Name',
					eventLabel: errorMessage
				});

			}

		});
		inlineRenameErrorObserver.observe(el, {
			attributes: true,
			subtree: true,
			childList: true
		});

	}

}

export default trackInlineRenameValidation;
